<template>
    <div class="ml-20">
        <a-list item-layout="horizontal">
            <a-list-item>
                <a-list-item-meta>
                    <div slot="title">
                        <span class="mt-5 mb-10" style="font-size: 14px;color: #610C9F !important;">
                            User Authentication & Verify
                        </span>
                    </div>
                    <div slot="description">
                        <span class="font-web" style="font-size: 14px;">
                            เพื่อความปลอดภัยของตัวท่านในการใช้งาน โปรดดำเนินการตามขั้นตอนต่อไปนี้
                        </span>
                    </div>
                    <a-avatar :style="{ backgroundColor: '#610C9F' }" slot="avatar" shape="square" :size="55" icon="lock" />
                </a-list-item-meta>
            </a-list-item>
        </a-list>

        <div>

            <h6 style="font-size: 12px;" class="font-web text-danger">*** แจ้งเพื่อทราบ ***</h6>
            <small style="font-size: 12px;" class="font-web text-danger">ข้อมูลไบโอเมทริกซ์จะไม่ถูกเก็บรวบรวมบนแอปพลิเคชัน
                และจะถูกนำไปใช้ในเครื่องเพื่อวัตถุประสงค์ในการตรวจสอบเท่านั้น</small>
            <br>
            <small style="font-size: 12px;" class="font-web text-danger">Your biometric information will not be collected by
                IC APP and will be used locally for verification purposes only.</small>
            <br>
        </div>

        <a-row class="text-center">
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">1</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-auth-01" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>MUIC Single Sign-on</i></h5>
                        <p class="m-0 font-web" style="color: #7C81AD;">
                            เข้าใช้งาน Application <br> Username & Password <br> ( MUIC ACCOUNT )
                        </p>
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">2</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-auth-02" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>PassCode</i></h5>
                        <p class="m-0 font-web" style="color: #7C81AD;">
                            สร้างรหัสผ่านที่เป็นตัวเลข 6 หลักสำหรับการใช้งาน Application
                        </p>
                    </template>
                    
                </a-result>
            </a-col>
            <a-col class="text-center" :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
                <a-result>
                    <template #icon>
                        <a-avatar class="mb-20" style="backgroundColor:#fdb913" :size="40">
                            <h4 style="color: #502b80;">3</h4>
                        </a-avatar>
                        <MobileFrame title="Overview" name="bg-auth-03" />
                    </template>
                    <template #title>
                        <h5 class="mb-10 font-web"><i>Biometric</i></h5>
                        <p class="m-0 font-web" style="color: #7C81AD;">
                            เปิดใช้งานระบบสแกนลายนิ้วมือ หรือ สแกนใบหน้า สำหรับใช้งานเฉพาะใน Application เท่านั้น
                        </p>
                    </template>
                    
                </a-result>
            </a-col>
        </a-row>


    </div>
</template>

<script>
import MobileFrame from '../MobileFrame.vue';

export default {
    components: {
        MobileFrame,
    },
    data() {
        return {}
    }
}
</script>